import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function SiteNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid ? 'bg-background-50/95 backdrop-blur border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <a
            href="#top"
            onClick={() => setMenuOpen(false)}
            className="flex items-center gap-2.5 shrink-0 cursor-pointer"
            aria-label="回到页面顶部"
          >
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-plant-line text-lg"></i>
            </span>
            <span className={`font-heading text-lg whitespace-nowrap ${solid ? 'text-foreground-950' : 'text-background-50'}`}>
              香蕉社区
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                className={`px-3 py-2 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  solid
                    ? 'text-foreground-700 hover:text-primary-700 hover:bg-primary-100/60'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#entrance"
              className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-compass-3-line"></i>
              查看入口类型
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
              aria-expanded={menuOpen}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
                solid ? 'text-foreground-950 hover:bg-background-200/70' : 'text-background-50 hover:bg-white/10'
              }`}
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/70">
          <nav className="px-4 py-3 grid grid-cols-1 sm:grid-cols-2 gap-1">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2.5 rounded-md text-sm text-foreground-800 hover:bg-primary-100/60 hover:text-primary-700 transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}